import { useStyles } from './styles'

const Teams = () => {
  useStyles()

  return <div>Teams</div>
}

export default Teams
